import {Resource} from '@raison/types';
import {CurrencyOptionView, TradeOptionView} from '~/processes/dashboard/CurrencySelectionPage/interfaces';
import * as selectOptionsFor from './selectors/CurrencyOptionViews';

export {selectFinancesDataStatus} from './financesPrimitives';
export {type FinancialData} from './financesReducer';
export {selectFinancesResource} from './financesResource';

type ResourceSelector<T> = (state: AppModel) => Resource<T>;
type RS<T> = ResourceSelector<T>;

export const selectSendOptionsView: RS<CurrencyOptionView[]> = selectOptionsFor._send;
export const selectReceiveOptionsView: RS<CurrencyOptionView[]> = selectOptionsFor._receive;
export const selectFiatTopupOptionsView: RS<CurrencyOptionView[]> = selectOptionsFor._topupFiat;
export const selectExchangeOptionsView: RS<CurrencyOptionView[]> = selectOptionsFor._exchange;
export const selectCryptoOptionsView: RS<CurrencyOptionView[]> = selectOptionsFor._buyCrypto;
export const selectTradeOptions: RS<TradeOptionView[]> = selectOptionsFor._trade;

export const selectOperationsSettings = (store: AppModel) => {
    if (store.finances.status === 'success') {
        return store.finances.data.operationsSettings;
    }
    return null;
};
